import { HttpClient } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable, of } from 'rxjs';
import { CategoryResponse, FavouriteCategories } from '../models/category';
import { ApiResponse } from '../models/apiResponse';
import { Brand } from '../models/brand';
import { GlobalComponent } from '../global-component';

const baseUrl = GlobalComponent.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class CategoryApiService {
  constructor(
    private httpClient: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  getActiveCategories(): Observable<CategoryResponse> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<CategoryResponse>(
        baseUrl + '/Category/GetActiveCategories'
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as CategoryResponse);
  }

  getCategoriesBySearchQuery(searchTerm: string): Observable<CategoryResponse> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<CategoryResponse>(
        baseUrl + '/Category/GetCategoriesByName?SearchTerm=' + searchTerm
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as CategoryResponse);
  }

  getCategoryBySeoName(seoName: string): Observable<CategoryResponse> {
    return this.httpClient.get<CategoryResponse>(
      baseUrl + '/Category/GetCategoryBySeoName?seoName=' + seoName
    );
  }

  getTopCategories(isTop: number): Observable<CategoryResponse> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<CategoryResponse>(
        baseUrl +
        '/Category/GetUITopCategories?IsTop=' +
        isTop +
        '&isHome=2&records=0'
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as CategoryResponse);
  }

  getHomeCategories(isHome: number): Observable<CategoryResponse> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<CategoryResponse>(
        baseUrl +
        '/Category/GetUITopCategories?IsHome=' +
        isHome +
        '&IsTop=2&records=4'
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as CategoryResponse);
  }

  getFavouriteCategories(): Observable<ApiResponse<FavouriteCategories>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<FavouriteCategories>>(
        baseUrl + '/Category/GetFavouriteCategories'
      );
    }
    return of({
      data: null,
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<FavouriteCategories>);
  }

  getRelatedStores(categoryId: number): Observable<ApiResponse<Brand[]>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<Brand[]>>(
        baseUrl + '/store/GetStoresByCategoryId?CategortId=' + categoryId
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<Brand[]>);
  }
}
